module.exports = __webpack_public_path__ + "static/media/van.fd39abec.svg";